import { useIntl } from 'react-intl'
import { AsideMenuItem } from './AsideMenuItem'

export function AsideMenuAnalista() {
  const intl = useIntl()

  return (
    <>
      <AsideMenuItem
        to='/empresas'
        title={intl.formatMessage({ id: 'MENU.EMPRESAS' })}
        fontIcon='bi bi-bag'
      />
      <AsideMenuItem
        to='/importar'
        title={intl.formatMessage({ id: 'MENU.IMPORTAR' })}
        fontIcon='fas fa-upload'
      />
      <AsideMenuItem
        to='/relatorioSelecionarCliente'
        title={intl.formatMessage({ id: 'MENU.RELATORIOS' })}
        fontIcon='bi bi-pie-chart'
      />
    </>
  )
}
